import { render, staticRenderFns } from "./CreatePaymentHeader.vue?vue&type=template&id=13db4262&"
import script from "./CreatePaymentHeader.vue?vue&type=script&lang=ts&"
export * from "./CreatePaymentHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports